<div class="document-forecast-chart__toolbar">
	<eif-custom-segmented-control
		[options]="chartTypeOptions"
		[value]="chartType"
		[size]="'small'"
		[variant]="'outlined'"
		(valueChange)="onChartTypeChange($event)">
	</eif-custom-segmented-control>
</div>
<div
	id="chart-1"
	class="dashboard-chart"
	#chartContainer>
	@if (chartType === 'line') {
		<ngx-charts-line-chart
			[scheme]="chart.ColorScheme"
			[customColors]="chart.CustomColors"
			[results]="chart.Results"
			[view]="chartView"
			[xAxis]="chart.ShowXAxis"
			[yAxis]="chart.ShowYAxis"
			[showXAxisLabel]="chart.ShowXAxisLabel"
			[xAxisLabel]="chart.XAxisLabel"
			[yAxisLabel]="chart.YAxisLabel"
			[showYAxisLabel]="chart.ShowYAxisLabel"
			[legend]="chart.ShowLegend"
			[legendTitle]="chart.LegendTitle"
			[legendPosition]="'below'"
			[autoScale]="true"
			[animations]="false">
			<ng-template
				#tooltipTemplate
				let-model="model">
				<!-- fields are series/name/value -->
				<div class="tt">
					<div>{{ model.series }} &#8226; {{ model.name }}</div>
					{{ model.value | currencyLocale: currency }}
				</div>
			</ng-template>
			<ng-template
				#seriesTooltipTemplate
				let-model="model">
				<div class="tt">
					@for (item of model; track item.series) {
						<div>
							@if (item.series) {
								{{ item.series }} &#8226;
							}
							{{ item.name }}
						</div>
						<div>{{ item.value | currencyLocale: currency }}</div>
					}
				</div>
			</ng-template>
		</ngx-charts-line-chart>
	} @else {
		<ngx-charts-bar-vertical-stacked
			[scheme]="chart.ColorScheme"
			[customColors]="chart.CustomColors"
			[results]="barResults"
			[view]="chartView"
			[xAxis]="chart.ShowXAxis"
			[yAxis]="chart.ShowYAxis"
			[showXAxisLabel]="chart.ShowXAxisLabel"
			[xAxisLabel]="chart.XAxisLabel"
			[yAxisLabel]="chart.YAxisLabel"
			[showYAxisLabel]="chart.ShowYAxisLabel"
			[legend]="chart.ShowLegend"
			[legendTitle]="chart.LegendTitle"
			[legendPosition]="'below'"
			[animations]="false">
			<ng-template
				#tooltipTemplate
				let-model="model">
				<div class="tt">
					<div>{{ model.name }} &#8226; {{ model.series }}</div>
					{{ model.value | currencyLocale: currency }}
				</div>
			</ng-template>
		</ngx-charts-bar-vertical-stacked>
	}
</div>
